import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import PrintOperations from 'src/scenes/PrintOperationsNew';
import { PrintSearchParams } from 'src/scenes/PrintOperationsNew/containers/Print/types';
import Status from 'src/scenes/Status';

const index = true;

export const printOperationsRouteObjectNew = inferRouteObject({
  path: 'print-operations-new',
  element: <PrivateRoute roles={Roles.MANAGE_PRINT_PRODUCTS} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: PrintOperations.Helmet,
      children: [
        {
          path: 'print',
          searchParams: PrintSearchParams.parse,
          children: [
            {
              index,
              Component: PrintOperations.Print,
            },
          ],
        },
        {
          path: 'publication-upload',
          Component: PrintOperations.PublicationUpload,
        },
        {
          index,
          element: <Navigate to='./print' replace />,
        },
      ],
    },
  ],
});
